import React, {Component} from 'react';
import {Switch} from "../../buttons/Swtich";
import {MetricsSelect} from "../../elements/MetricsSelect";
import {PeriodsSelect} from "../../elements/PeriodsSelect";
import {ALL_PERIODS, getPropertiesForPeriod} from "../../../periods";
import { withTranslation } from 'react-i18next';

class FlexIndicatorConfigurationClass extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isEnabled: this.isEnabled(),
            metricName: this.getMetricName(),
            mainPeriod: this.getMainPeriod(),
            vsPeriod: this.getVsPeriod()
        }

        this.handleSwitchChange = this.handleSwitchChange.bind(this);
        this.handleSelectedOptionMetricNameChange = this.handleSelectedOptionMetricNameChange.bind(this);
        this.handleMainPeriodChange = this.handleMainPeriodChange.bind(this);
        this.handleVsPeriodChange = this.handleVsPeriodChange.bind(this);
    }

    handleSwitchChange(event) {
        const isActive = event.target.checked;

        if (!isActive) {
            this.setState({
                isEnabled: false,
                metricName: null,
                mainPeriod: null,
                vsPeriod: null
            });
            this.props.onChange(this.props.order, null);
        } else {
            this.setState({
                isEnabled: true
            });
            this.props.onChange(this.props.order, {
                "metricName": this.state.metricName,
                "mainPeriod": this.state.mainPeriod,
                "vsPeriod": this.state.vsPeriod
            });
        }
    }

    handleSelectedOptionMetricNameChange(event) {
        const metricName = event.target.value;

        this.setState({
            metricName: metricName
        });
        this.props.onChange(this.props.order, {
            "metricName": metricName,
            "mainPeriod": this.state.mainPeriod,
            "vsPeriod": this.state.vsPeriod
        });
    }

    handleMainPeriodChange(event) {
        const mainPeriod = event.target.value;

        this.setState({mainPeriod: mainPeriod});

        this.props.onChange(this.props.order, {
            "metricName": this.state.metricName,
            "mainPeriod": mainPeriod,
            "vsPeriod": this.state.vsPeriod
        });
    }

    handleVsPeriodChange(event) {
        const vsPeriod = event.target.value === '' ? null : event.target.value;

        this.setState({vsPeriod: vsPeriod});

        this.props.onChange(this.props.order, {
            "metricName": this.state.metricName,
            "mainPeriod": this.state.mainPeriod,
            "vsPeriod": vsPeriod
        });
    }

    isEnabled() {
        return this.props.data !== null
    }

    getMetricName() {
        if (!this.isEnabled()) {
            return null;
        }

        return this.props.data["metricName"]
    }

    getMainPeriod() {
        if (!this.isEnabled()) {
            return null;
        }
        return this.props.data["mainPeriod"]
    }

    getVsPeriod() {
        if (!this.isEnabled()) {
            return null;
        }
        return this.props.data["vsPeriod"]
    }

    renderMainPeriodInput() {
        const { t } = this.props;
        const value = !this.state.isEnabled ? "" : this.state.mainPeriod;
        const propertiesForPeriod = getPropertiesForPeriod(t);

        return (
            <div className="flex-indicator-card__field">
                <label>{t('flex_indicator_configuration.in_period')}</label>
                <PeriodsSelect name="mainPeriod"
                               onChange={this.handleMainPeriodChange}
                               value={value}
                               disabled={!this.state.isEnabled}
                               periods={ALL_PERIODS.filter(period => !propertiesForPeriod[period]["depends_of_other_period"])}
                />
            </div>
        );
    }

    renderVsPeriodInput() {
        const { t } = this.props;
        const value = !this.state.isEnabled ? "" : this.state.vsPeriod;

        return (
            <div className="flex-indicator-card__field">
                <label>{t('flex_indicator_configuration.compared_with')}</label>
                <PeriodsSelect name="vsPeriod"
                               onChange={this.handleVsPeriodChange}
                               value={value}
                               disabled={!this.state.isEnabled}
                               emptyOptionText={t('flex_indicator_configuration.no_comparison')}
                />
            </div>
        );
    }

    renderMetricNameInput() {
        const { t } = this.props;
        const value = !this.state.isEnabled ? "" : this.state.metricName;

        return (
            <div className="flex-indicator-card__field">
                <label>{t('flex_indicator_configuration.metric')}</label>
                <MetricsSelect name="metricName"
                               onChange={this.handleSelectedOptionMetricNameChange}
                               value={value}
                               disabled={!this.state.isEnabled}
                               includeCustomMetrics={true}
                />
            </div>
        );
    }

    render() {
        const { t } = this.props;
        const cardClass = this.state.isEnabled ? 'flex-indicator-card flex-indicator-card--active' : 'flex-indicator-card';

        return (
            <div className={cardClass}>
                <div className="flex-indicator-card__header">
                    <span className="flex-indicator-card__number">#{this.props.order}</span>
                    <Switch
                        centered={true}
                        onChange={this.handleSwitchChange}
                        checked={this.state.isEnabled}
                        name="goalIsActive"
                        messageToAlertUserIfChecked={null}
                        style={{ margin: 0 }}
                    />
                    {!this.state.isEnabled && (
                        <span className="flex-indicator-card__placeholder">
                            {t('flex_indicator_configuration.not_configured')}
                        </span>
                    )}
                </div>
                {this.state.isEnabled && (
                    <div className="flex-indicator-card__body">
                        {this.renderMetricNameInput()}
                        {this.renderMainPeriodInput()}
                        {this.renderVsPeriodInput()}
                    </div>
                )}
            </div>
        );
    }
}

export const FlexIndicatorConfiguration = withTranslation()(FlexIndicatorConfigurationClass);
export default FlexIndicatorConfiguration;
